import React from 'react';
import './LevelSelect.css';

interface LevelSelectProps {
  selectedLevel: 4 | 6 | 8;
  onLevelChange: (level: 4 | 6 | 8) => void;
}

const LevelSelect: React.FC<LevelSelectProps> = ({ selectedLevel, onLevelChange }) => {
  const levels: Array<{ size: 4 | 6 | 8; label: string; description: string }> = [
    { size: 4, label: 'Easy', description: '4×4 Grid' },
    { size: 6, label: 'Medium', description: '6×6 Grid' },
    { size: 8, label: 'Hard', description: '8×8 Grid' }
  ];

  return (
    <div className="level-select-container">
      <h3 className="level-select-title">Select Difficulty</h3>
      <div className="level-select-buttons">
        {levels.map(({ size, label, description }) => (
          <button
            key={size}
            className={`level-button ${selectedLevel === size ? 'selected' : ''}`}
            onClick={() => onLevelChange(size)}
          >
            <div className="level-label">{label}</div>
            <div className="level-description">{description}</div>
          </button>
        ))}
      </div>
    </div>
  );
};

export default LevelSelect;
